import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Subaccount } from "@design-system/Subaccount/Subaccount";

export const SubaccountCell = memo(
    ({ row }: CellContext<ViewTableFeatures, TransactionListItem, any>) =>
        row.original.subaccount && (
            <ViewTableCell>
                <Subaccount subaccount={row.original.subaccount} />
            </ViewTableCell>
        ),
);
SubaccountCell.displayName = "SubaccountCell";
